import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './HComment.module.scss';
const HComment = ({ mode = 'lb', className = '' }) => {
    return _jsx("div", Object.assign({ className: classNames(styles.hComment, styles[mode], className) }, { children: "c" }));
};
export default memo(HComment);
